import './index.scss';

import 'custom-event-polyfill';
import '@ri-digital/web-data-layer';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AppProviders } from './AppProviders';
import { initFaro } from './faro';

if (process.env.NODE_ENV === 'development') {
  const { worker } = require('./mocks/browser');
  worker.start({ onUnhandledRequest: 'bypass' });
}

initFaro();

ReactDOM.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
  document.getElementById('login'),
);
